<template>
  <div class="warp">
    <div class="dashboard-header">
      <div class="logo">
        <!-- <img width="68px" height="68px" :src="logoPath" alt="" srcset="" /> -->
      </div>
      <div class="title">
        <div class="text">欢迎来到{{ config.HospitalName }}</div>
        <div class="time">今日日历：{{ nowDate }}</div>
      </div>
    </div>
    <div class="dashboard-content">
      <div class="content-left">
        <div class="content-header">
          <el-tabs class="app-tabs" v-model="model" @tab-click="handleClick" stretch>
            <el-tab-pane v-for="item in apps" :key="item.id" :name="item.id + ''">
              <template slot="label">
                <span style="margin: 0 10px; font-size: 12px">
                  {{ item.name }}
                </span>
              </template>
            </el-tab-pane>
          </el-tabs>
          <div class="header-time-div">
            <!-- <el-tabs v-model="timeValue" @tab-click="timeChange">
              <el-tab-pane v-for="item in apps" :key="item.id" :name="item.id + ''">
                <template slot="label">
                  <span style="margin: 0 10px;font-size:12px;">
                    {{ item.name }}
                  </span>
                </template>
              </el-tab-pane>
            </el-tabs> -->
            <div class="date-range-div" v-if="model == '2'">
              <el-date-picker v-model="dataRangeValue" type="daterange" range-separator="至" start-placeholder="年/月/日"
                end-placeholder="年/月/日" @change="dateChange">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="content-info">
          <template v-if="model == '2'">
            <div class="asset-info">
              <div class="fixed-info card">
                <div class="info-title">固定资产概览</div>
                <div class="info-content">
                  <div class="info-item">
                    <div class="circle color-1"></div>
                    <div class="item-info">
                      <div class="number">{{ FixedAssetData.fixedAsset }}</div>
                      <div class="name">资产总数</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="circle color-2"></div>
                    <div class="item-info">
                      <div class="number">{{ FixedAssetData.inUse }}</div>
                      <div class="name">在用资产数</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="circle color-3"></div>
                    <div class="item-info">
                      <div class="number">{{ FixedAssetData.assetCard }}</div>
                      <div class="name">建卡资产数</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="circle color-4"></div>
                    <div class="item-info">
                      <div class="number">
                        {{ RateFomatter(FixedAssetData.assetUtilizationRate) }}
                      </div>
                      <div class="name">资产利用率（%）</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="work-order-info card">
                <div class="info-title">资产工单概览</div>
                <div class="info-content">
                  <div class="info-item" v-for="(item, index) in ShoWworkOrderData" :key="index">
                    <div class="circle" :class="'color-2' + item.colorIndex"></div>
                    <div class="item-info">
                      <div class="number">{{ OrderAndExpData[item.prop] }}</div>
                      <div class="name">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
                <div class="btn-group">
                  <div class="left-triangle" :class="{ active: leftActive() }" v-preventReClick @click="lastPage"></div>
                  <div class="right-triangle" :class="{ active: rightActive() }" v-preventReClick @click="nextPage">
                  </div>
                </div>
              </div>
              <div class="finance-info card">
                <div class="info-title">财政收支概览</div>
                <div class="info-content">
                  <div class="info-item">
                    <div class="circle color-31"></div>
                    <div class="item-info">
                      <div class="number">{{ OrderAndExpData.totalValue }}</div>
                      <div class="name">资产总价值（￥）</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="circle color-32"></div>
                    <div class="item-info">
                      <div class="number">
                        {{ OrderAndExpData.purchasePay }}
                      </div>
                      <div class="name">采购支出（￥）</div>
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="circle color-33"></div>
                    <div class="item-info">
                      <div class="number">
                        {{ OrderAndExpData.disposalIncome }}
                      </div>
                      <div class="name">处置收入（￥）</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="model == '3'">
            <div class="consumables-info">
              <div class="certificate-top card">
                <div class="info-title">医疗耗材概览</div>
                <div class="info-content">
                  <el-row>
                    <el-col :span="8" v-for="(item, index) in consumablesLabelData" :key="index">
                      <span class="name" @click="toLabelContent(item)">{{
                        item.title
                        }}</span>
                      <span class="number" @click="toLabelContent(item)">{{
                        item.number
                        }}</span>
                      <span class="name" @click="toLabelContent(item)">{{
                        item.unit
                        }}</span>
                    </el-col>
                    <!-- <el-col :span="8">
                      <span class="name">近6个月过期库存</span>
                    </el-col>
                    <el-col :span="8">
                      <span class="name">近6个月过期库存</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <span class="name">近6个月过期库存</span>
                    </el-col>
                    <el-col :span="8">
                      <span class="name">近6个月过期库存</span>
                    </el-col>
                    <el-col :span="8">
                      <span class="name">近6个月过期库存</span>
                    </el-col> -->
                  </el-row>
                  <!-- <div class="info-item" v-for="(item, index) in consumablesLabelData" :key="index" @click="toLabelContent(item)">
                    <div class="circle" :class="'color-2' + item.colorIndex"></div>
                    <div class="item-info">
                      <div class="number">{{ item.number }}</div>
                      <div class="name">{{ item.title }}</div>
                    </div>
                  </div> -->
                </div>
                <!-- <div class="btn-group">
                  <div class="left-triangle" :class="{ active: consumablesLeftActive() }" v-preventReClick @click="consumablesLastPage"></div>
                  <div class="right-triangle" :class="{ active: consumablesRightActive() }" v-preventReClick @click="consumablesNextPage"></div>
                </div> -->
              </div>
              <div class="certificate-group">
                <div class="certificate-left card">
                  <div class="left-top cro">
                    <div class="info-title">
                      证件预警
                      <span class="view" @click="viewEvt">查看</span>
                    </div>

                    <!-- <div class="cro_left_bottom"></div>
                                    <div class="cro_right_bottom"></div> -->
                  </div>
                  <div class="left-bottom cro">
                    <div class="info-label">
                      <span> 过期详情 </span>
                      <!-- <el-input placeholder="搜索厂家名字/编号/证件名称" suffix-icon="el-icon-search" style="width:60%">
                      </el-input> -->
                    </div>
                    <el-table ref="multipleTable" border :data="supplierData" :show-header="false"
                      style="width: 100%; margin-top: 20px">
                      <el-table-column min-width="20%" label align="center" class="top">
                        <template slot-scope="scope">{{ scope.row.name }}</template>
                      </el-table-column>
                      <el-table-column id="test1" min-width="20%" label align="center">
                        <template slot-scope="scope">
                          <div class="grid-cont-right">
                            <div class="grid-num" style="color: rgb(45, 140, 240)">
                              {{ scope.row.sixMonthNumber }}
                            </div>
                            <div>六个月过期</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column min-width="20%" label align="center">
                        <template slot-scope="scope">
                          <div class="grid-cont-right">
                            <div class="grid-num" style="color: rgb(45, 140, 240)">
                              {{ scope.row.threeMonthNumber }}
                            </div>
                            <div>三个月过期</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column min-width="20%" label align="center">
                        <template slot-scope="scope">
                          <div class="grid-cont-right">
                            <div class="grid-num" style="color: rgb(45, 140, 240)">
                              {{ scope.row.thisMonthNumber }}
                            </div>
                            <div>一个月过期</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label min-width="20%" align="center">
                        <template slot-scope="scope">
                          <div class="grid-cont-right">
                            <div class="grid-num" style="color: rgb(242, 94, 67)">
                              {{ scope.row.overdueNumber }}
                            </div>
                            <div>已过期</div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- <div class="cro_left_top"></div> -->
                    <!-- <div class="cro_right_top"></div> -->
                    <!-- <div class="spd-pagination">
                                        <el-pagination background layout="prev, pager, next" :current-page="supplierQuery.pageIndex" :page-size="supplierQuery.pageSize" :total="supplierPageTotal" @current-change="supplierPageChange">
                                        </el-pagination>
                                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="content-right">
        <div class="msg-header">
          <div class="info-title">
            系统消息
            <span style="font-size: 10px; color: red">共{{ this.messagePageTotal }}条</span>
          </div>
          <div class="msg-more" @click="toMessage">更多</div>
        </div>
        <!-- 系统消息 -->
        <ul>
          <el-tooltip v-for="(item, index) in messageData" :key="index" class="item" :content="item.content"
            placement="left">
            <li class="new-item">
              <!-- <el-badge value="new" class="item"> -->
              <div class="new-title" @click="toMessageContent(item)">
                {{ item.content }}
              </div>
              <!-- </el-badge> -->
              <div class="cro_left_top"></div>
              <div class="cro_right_top"></div>
              <div class="spd-pagination" style="padding: 17px">
                <el-pagination background layout="prev, pager, next" :current-page="query.pageIndex"
                  :page-size="query.pageSize" :pager-count="5" :total="messagePageTotal"
                  @current-change="messagePageChange">
                </el-pagination>
              </div>
            </li>
          </el-tooltip>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import {
  GetFixedAssetOverView,
  GetWorkOrderAndExpenditureOverView,
  GetHomeData,
  GetManufacturerValidityData,
  GetProductValidityData,
  GetMessages,
  ReadedMessage,
} from "@/api";
import { AppCategoryIndexOption, TimeIndexOption } from "@/enum";
// import { mapState } from 'vuex'
import { getLogoPath } from "@/utils/logo";

export default {
  components: {},
  /** 定义属性 */
  data () {
    return {
      config: config,
      model: "2",
      timeValue: "0",
      nowDate: "",
      AppCategoryIndexOption: AppCategoryIndexOption,
      TimeIndexOption: TimeIndexOption,
      dataRangeValue: [],
      dataRange: [],
      thisApps: [],
      workOrderData: [
        {
          prop: "unRepair",
          title: "待维修资产",
          colorIndex: 1,
        },
        {
          prop: "repairFinish",
          title: "已维修资产",
          colorIndex: 2,
        },
        {
          prop: "unMetering",
          title: "待计量资产",
          colorIndex: 3,
        },
        {
          prop: "unMaintain",
          title: "待保养资产",
          colorIndex: 4,
        },
        {
          prop: "unPatrol",
          title: "待巡检质控资产",
          colorIndex: 5,
        },
        {
          prop: "unDisposal",
          title: "待处置资产",
          colorIndex: 6,
        },
        {
          prop: "disposalFinish",
          title: "已处置资产",
          colorIndex: 7,
        },
      ],
      workOrderPage: 1,
      ShoWworkOrderData: [],
      FixedAssetData: {
        assetCard: 0,
        assetUtilizationRate: 0,
        fixedAsset: 0,
        inUse: 0,
      },
      OrderAndExpData: {
        disposalFinish: 0,
        disposalIncome: 0,
        purchasePay: 0,
        repairFinish: 0,
        totalValue: 0,
        unDisposal: 0,
        unMaintain: 0,
        unMetering: 0,
        unPatrol: 0,
        unRepair: 0,
      },

      consumablesLabelData: [
        // { prop: "data1", title: "本月过期产品数", colorIndex: 1, number: 1 },
        // { prop: "data2", title: "超库存上限产品数", colorIndex: 2, number: 3 },
        // { prop: "data3", title: "超库存下限产品数", colorIndex: 3, number: 5 },
        // { prop: "data4", title: "超库存下限产品数1", colorIndex: 4 },
        // { prop: "data5", title: "超库存下限产品数2", colorIndex: 5 },
        {
          prop: "sixMonthOverdueStock",
          title: "近6个月过期库存",
          colorIndex: 1,
          number: 0,
          unit: "个",
        },
        {
          prop: "runningSupplierProductUpdate",
          title: "待审批的供应商产品维护",
          colorIndex: 2,
          number: 0,
          unit: "个",
        },
        {
          prop: "supplierProductCertDetail",
          title: "待审批的供应商产品证件",
          colorIndex: 3,
          number: 0,
          unit: "个",
        },
        {
          prop: "autoPurchaseApply",
          title: "自动申领待处理",
          colorIndex: 4,
          number: 0,
          unit: "条",
        },
        {
          prop: "sixMonthCertOverdueSupplierProduct",
          title: "证照近6个月到期的供应商产品",
          colorIndex: 5,
          number: 0,
          unit: "个",
        },
        {
          prop: "certOverdueSupplierProduct",
          title: "证照已过期的供应商产品",
          colorIndex: 6,
          number: 0,
          unit: "个",
        },
        {
          prop: "expireContract",
          title: "执行期内集采合同超量",
          colorIndex: 6,
          number: 0,
          unit: "个",
        },
      ],
      consumablesPage: 1,
      ShowConsumablesData: [],
      messageData: [],
      warnData: [],
      thisMonthOverdueStock: 0,
      aboveMaxStockNumber: 0,
      belowMinStockNumber: 0,
      productData: [],
      productResultData: [],
      productPageTotal: 0,
      messagePageTotal: 0,
      supplierData: [],
      supplierResultData: [],
      supplierPageTotal: 0,

      supplierQuery: {
        pageIndex: 1,
        pageSize: 4,
      },
      productQuery: {
        pageIndex: 1,
        pageSize: 4,
      },
      query: {
        pageIndex: 1,
        pageSize: 20,
        state: 0,
        category: 1, // 系统消息栏
      },

      logoPath: getLogoPath(),
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {
    apps () {
      // 当前用户拥有的app
      let apps = this.$store.state.user.apps;
      this.thisApps = apps;
      // 用户过滤后的app
      let thisApps = apps.filter((e) => ![1,4].includes(e.id));
      return thisApps;
    },
    userInfo () {
      return this.$store.state.user.userInfo;
    },
  },
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    init () {
      this.nowDate = this.parseTime(new Date(), "{y}-{m}-{d}");
      this.timeChange({
        index: this.timeValue ? this.timeValue : "0",
      });
      this.setWorkOrderData();
      this.setConsumablesData();

      this.getMessages();
      this.getSpdHomeData();
      this.getManuValidityData(0);
      this.getProductValidityData(0);
    },
    getAssetData () {
      GetFixedAssetOverView().then((res) => {
        this.FixedAssetData = res.returnData;
      });
    },
    getWorkOrderAndExp () {
      GetWorkOrderAndExpenditureOverView({
        pageIndex: 1,
        pageSize: 10000,
        startDate: this.dataRange[0],
        endDate: this.dataRange[1],
      }).then((res) => {
        this.OrderAndExpData = res.returnData;
      });
    },
    handleClick (e) {
      this.workOrderPage = 1;
      this.consumablesPage = 1;
      switch (e.index) {
        case "0":
          this.getAssetData();
          this.timeChange({
            index: this.timeValue ? this.timeValue : "0",
          });
          break;
        case "1":
          this.timeChange({
            index: this.timeValue ? this.timeValue : "0",
          });
          break;
      }
    },
    timeChange (e) {
      var dateNow = new Date(this.parseTime(new Date(), "{y}-{m}-{d}"));
      var startDate = null;
      switch (e.index) {
        case "0":
          // 昨日
          startDate = this.GetPreDay(dateNow, 0, 0, 1);
          dateNow = startDate;
          this.dataRange = [startDate, dateNow];
          break;
        case "1":
          // 近一月
          startDate = this.GetPreDay(dateNow, 0, 1, 0);
          break;
        case "2":
          // 近季度
          startDate = this.GetPreDay(dateNow, 0, 3, 0);
          break;
        case "3":
          // 近半年
          startDate = this.GetPreDay(dateNow, 0, 6, 0);
          break;
        case "4":
          // 近一年
          startDate = this.GetPreDay(dateNow, 1, 0, 0);
          break;
        case "5":
          // 累计
          dateNow = null;
          break;
      }
      this.dataRange = [startDate, dateNow];
      this.getWorkOrderAndExp();
      this.dataRangeValue = null;
    },
    RateFomatter (val) {
      return this.toDecimal(val * 100, 2) + "%";
    },
    setWorkOrderData () {
      this.ShoWworkOrderData = this.workOrderData.slice(
        this.workOrderPage - 1,
        this.workOrderPage - 1 + 4
      );
    },
    lastPage () {
      if (this.workOrderPage > 1) {
        this.workOrderPage--;
      }
      this.setWorkOrderData();
    },
    nextPage () {
      if (this.workOrderPage < this.workOrderData.length - 3) {
        this.workOrderPage++;
      }
      this.setWorkOrderData();
    },
    leftActive () {
      return this.workOrderPage > 1;
    },
    rightActive () {
      return this.workOrderPage < this.workOrderData.length - 3;
    },
    setConsumablesData () {
      this.ShowConsumablesData = this.consumablesLabelData.slice(
        this.consumablesPage - 1,
        this.consumablesPage - 1 + 3
      );
    },
    consumablesLastPage () {
      if (this.consumablesPage > 1) {
        this.consumablesPage--;
      }
      this.setConsumablesData();
    },
    consumablesNextPage () {
      if (this.consumablesPage < this.consumablesLabelData.length - 2) {
        this.consumablesPage++;
      }
      this.setConsumablesData();
    },
    consumablesLeftActive () {
      return this.consumablesPage > 1;
    },
    consumablesRightActive () {
      return this.consumablesPage < this.consumablesLabelData.length - 2;
    },
    GetPreDay (date, yearNum, monthNum, dayNum) {
      var dataStr = this.parseTime(date, "{y}-{m}-{d}");
      var dateArr = dataStr.split("-");
      var year = dateArr[0]; //获取当前日期的年份
      var month = dateArr[1]; //获取当前日期的月份
      var day = dateArr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = parseInt(year) - yearNum;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        var absM = Math.abs(month2);
        year2 = parseInt(year2) - Math.ceil(absM / 12 == 0 ? 1 : parseInt(absM) / 12);
        month2 = 12 - (absM % 12);
      }
      var day2 = parseInt(day) - dayNum == 0 ? "01" : parseInt(day) - dayNum;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = "0" + month2;
      }
      var t2 = year2 + "-" + month2 + "-" + day2;
      return t2;
    },
    dateChange (e) {
      this.dataRange = this.dataRangeValue;
      switch (model) {
        case "0":
          this.getWorkOrderAndExp();
          break;
        case "1":
          this.setConsumablesData();
          break;
      }
    },

    toMessage () {
      // alert("这里是消息");
      this.$router.push("/system-message");
    },
    // spd
    getMessages () {
      // var query = {
      //   pageIndex: 1,
      //   pageSize: 20,
      //   state: 0
      // }
      GetMessages(this.query).then((res) => {
        this.messageData = res.returnData.data;
        this.messagePageTotal = res.returnData.dataCount;

        eventBus.$emit("MessageCount", this.messagePageTotal);
      });
    },
    getSpdHomeData () {
      GetHomeData().then((res) => {
        this.warnData = res.returnData.validityWarns;
        this.supplierData = res.returnData.validityWarns;
        // this.consumablesLabelData[0].number = res.returnData.thisMonthOverdueStock
        // this.consumablesLabelData[1].number = res.returnData.aboveMaxStockNumber
        // this.consumablesLabelData[2].number = res.returnData.belowMinStockNumber

        this.consumablesLabelData[0].number = res.returnData.sixMonthOverdueStock;
        this.consumablesLabelData[1].number = res.returnData.runningSupplierProductUpdate;
        this.consumablesLabelData[2].number = res.returnData.supplierProductCertDetail;
        this.consumablesLabelData[3].number = res.returnData.autoPurchaseApply;
        this.consumablesLabelData[4].number =
          res.returnData.sixMonthCertOverdueSupplierProduct;
        this.consumablesLabelData[5].number = res.returnData.certOverdueSupplierProduct;
        this.consumablesLabelData[6].number = res.returnData.expireContract;
      });
    },
    getManuValidityData (type) {
      GetManufacturerValidityData({
        validityType: type,
      }).then((res) => {
        this.supplierResultData = res.returnData;
        this.supplierData = this.getPaginationData(
          this.supplierResultData,
          this.supplierQuery.pageIndex,
          this.supplierQuery.pageSize
        );
        this.supplierPageTotal = res.returnData ? res.returnData.length : 0;
      });
    },
    getProductValidityData (type) {
      GetProductValidityData({
        validityType: type,
      }).then((res) => {
        this.productResultData = res.returnData;
        this.productData = this.getPaginationData(
          this.productResultData,
          this.productQuery.pageIndex,
          this.productQuery.pageSize
        );
        this.productPageTotal = res.returnData ? res.returnData.length : 0;
      });
    },
    getPaginationData (list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    supplierPageChange (val) {
      this.$set(this.supplierQuery, "pageIndex", val);
      this.supplierData = this.getPaginationData(
        this.supplierResultData,
        this.supplierQuery.pageIndex,
        this.supplierQuery.pageSize
      );
    },
    productPageChange (val) {
      this.$set(this.productQuery, "pageIndex", val);
      this.productData = this.getPaginationData(
        this.productResultData,
        this.productQuery.pageIndex,
        this.productQuery.pageSize
      );
    },
    //  messagePageChange (val) {
    //   this.$set(this.messageQuery, 'pageIndex', val)
    //   this.messageData = this.getPaginationData(this.messageResultData, this.messageQuery.pageIndex, this.messageQuery.pageSize)
    // },
    // 改变当前页
    messagePageChange (val) {
      this.$set(this.query, "pageIndex", val);
      this.getMessages();
    },

    toLabelContent (label) {
      if (label.prop == "sixMonthOverdueStock") {
        // this.$router.push("/stock");
        var now = new Date();
        var yesterDay = new Date(now.setDate(now.getDate() - 1));
        var endDate = new Date(yesterDay.setMonth(yesterDay.getMonth() + 6));
        console.log(endDate, "近6个月过期库存");
        
        this.$router.push({
          name: "Stock",
          params: {
            expiryStatus:'3',
            startDate: this.parseTime(new Date()),
            // endDate: this.parseTime(endDate),
          },
        });
      } else if (label.prop == "runningSupplierProductUpdate") {
        this.$router.push({
          name: "SupplierProductUpdate",
        });
      } else if (label.prop == "supplierProductCertDetail") {
        this.$router.push({
          name: "SupplierProduct",
          params: {
            certApproveType: 2,
          },
        });
      } else if (label.prop == "autoPurchaseApply") {
        this.$router.push({
          name: "AutoPurchaseApply",
          params: {
            approveId: this.userInfo.id,
          },
        });
      } else if (label.prop == "sixMonthCertOverdueSupplierProduct") {
        var now = new Date();
        var yesterDay = new Date(now.setDate(now.getDate() - 1));
        var endDate = new Date(yesterDay.setMonth(yesterDay.getMonth() + 6));
        this.$router.push({
          name: "SupplierProduct",
          params: {
            certStartDate: new Date(),
            certEndDate: endDate,
          },
        });
      } else if (label.prop == "certOverdueSupplierProduct") {
        this.$router.push({
          name: "SupplierProduct",
          params: {
            certStartDate: new Date("1970-1-1"),
            certEndDate: new Date(),
          },
        });
      } else if (label.prop == "expireContract") {
        this.$router.push({
          name: "SpdContractExpire",
        });
      }
    },

    toMessageContent (message) {
      // if (!message.tableCode) {
      //   // 已读消息
      //   ReadedMessage({ ids: [message.id] })
      //   this.getMessages()
      //   return;
      // }

      console.log(message, "系统消息message");
      if (message.type == 1) {
        // 已读消息
        ReadedMessage({
          ids: [message.id],
        });
        this.getMessages();
        return;
      }

      let route;
      let editRoute;
      let routes = this.$store.getters.permission_routes;
      for (let i = 0; i < routes.length; i++) {
        if (routes[i].name == message.tableCode) {
          route = routes[i];
          // this.parentRoute = routes[i]
        }
        if (routes[i].name == message.tableCode + "Edit") {
          editRoute = routes[i];
        }

        if (routes[i].children && routes[i].children.length > 0) {
          for (let j = 0; j < routes[i].children.length; j++) {
            if (routes[i].children[j].name == message.tableCode) {
              route = routes[i].children[j];
            }
            if (routes[i].children[j].name == message.tableCode + "Edit") {
              editRoute = routes[i].children[j];
            }
          }
        }
      }

      if (!route) {
        // 已读消息
        ReadedMessage({
          ids: [message.id],
        });
        this.getMessages();
        return;
      }

      let path = route.path.replace("/", "");
      if (editRoute) {
        path = editRoute.path.replace("/", "");
      }

      if (message.title == "流程审批") {
        this.$router.push("/" + path + "?formMode=3&id=" + message.dataId);
      } else {
        // 已读消息
        ReadedMessage({
          ids: [message.id],
        });
        this.$router.push("/" + path + "?formMode=0&id=" + message.dataId);
      }
    },
    viewEvt () {
      this.$router.push("/documentWarning");
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () { },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    // if (this.model == null || this.model == 0) {
    // 默认都有工作台，解决过滤后apps是空的问题,给thisApps赋值
    // 首页取第2个。原先是第一个：apps[0]
    this.model = this.thisApps[1].id + "";
    // }
    this.init();
    if (this.logoPath.startsWith("@")) {
      this.logoPath = require(`@/assets/logo.png`);
    }
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  padding: 0;
}

/deep/.el-input__inner {
  border: 0;
}

/deep/.el-range__icon {
  display: none;
}

.el-date-editor {
  width: 240px;
}

.warp {
  padding: 20px 0;
  height: 100%;
  box-sizing: border-box;

  .dashboard-header {
    background: url("../../../assets/background.png") no-repeat 100% 100% / 100% 100%;
    // box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
    opacity: 0.9;
    border-radius: 2px;
    height: 180px;
    background-color: #e1eff9;
    align-items: center;
    display: flex;

    .logo {
      padding: 0 20px;

      img {
        border-radius: 34px;
      }
    }

    .title {
      line-height: 50px;
      color: #286ab4;

      .text {
        font-size: 30px;
        font-weight: bold;
        color: #286ab4;
        text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      }

      .time {
        padding-left: 15px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .dashboard-content {
    box-sizing: inherit;
    display: flex;
    height: calc(100% - 180px);

    .content-left {
      box-sizing: inherit;
      padding-right: 20px;
      width: 77%;

      .content-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .header-time-div {
          padding-left: 30px;
          display: inherit;
          align-items: center;

          .date-range-div {
            height: 39px;
            margin-left: 30px;
            font-size: 12px;
            border-bottom: 1px solid rgba(40, 106, 180, 0.5);
            box-sizing: border-box;
            line-height: 40px;
          }
        }
      }

      .content-info {
        height: calc(100% - 49px);

        // height: calc(100% - 0px);
        .asset-info {
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .consumables-info {
          height: 100%;

          .certificate-top {
            height: 24%;

            .btn-group {
              position: absolute;
              top: calc(50%);
              width: calc(100% - 20px);

              .left-triangle {
                width: 0;
                height: 0;
                border-top: 15px solid transparent;
                border-right: 20px solid rgba(40, 106, 180, 0.5);
                border-bottom: 15px solid transparent;
                float: left;
                cursor: pointer;
              }

              .left-triangle.active {
                border-right: 20px solid #286ab4;
              }

              .right-triangle {
                float: right;
                width: 0;
                height: 0;
                border-top: 15px solid transparent;
                border-left: 20px solid rgba(40, 106, 180, 0.5);
                border-bottom: 15px solid transparent;
                position: absolute;
                right: 0;
                cursor: pointer;
              }

              .right-triangle.active {
                border-left: 20px solid #286ab4;
              }
            }
          }

          .certificate-group {
            box-sizing: border-box;
            height: 74.25%;

            .certificate-left {
              height: 100%;
              margin-right: 1.5%;

              .left-top {
                /*height: 25%;*/
                border-bottom: 1px dashed rgba(40, 106, 180, 0.2);
              }

              .left-bottom {
                height: calc(75% - 40px);
              }

              .left-top,
              .left-bottom {
                padding: 10px;
              }
            }

            .certificate-right {
              height: 100%;

              .right-top {
                height: 25%;
                border-bottom: 1px dashed rgba(40, 106, 180, 0.2);
              }

              .right-bottom {
                height: calc(75% - 40px);
              }

              .right-top,
              .right-bottom {
                padding: 10px;
              }
            }

            .certificate-left,
            .certificate-right {
              box-sizing: border-box;
              /*width: 49.25%;*/
              margin-bottom: 0;
              padding: 0;
            }
          }
        }
      }
    }

    .content-right {
      box-sizing: inherit;
      margin-top: 49px;
      width: 23%;
      background-color: #eef6ff;
      border-radius: 2px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
      padding: 17px 20px;

      .msg-header {
        display: flex;
        justify-content: space-between;

        .msg-more {
          font-size: 12px;
          font-weight: 400;
          line-height: 24px;
          color: #606166;
          cursor: pointer;
        }

        .msg-more:hover {
          color: #286ab4;
        }
      }

      ul {
        padding-inline-start: 0px;
        width: 100%;

        .new-item {
          width: 100%;
          list-style: none;
          cursor: pointer;
          white-space: nowrap;
          transition: 0.2s;

          .item {
            width: 90%;
          }

          .new-title {
            line-height: 24px;
            font-size: 14px;
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .new-item:hover {
          color: #286ab4;
          transition: 0.2s;
        }
      }
    }
  }

  .card {
    box-sizing: border-box;
    margin-bottom: 1.25%;
    height: 32.5%;
    width: 100%;
    background-color: #f5f6fa;
    border-radius: 2px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
    padding: 10px 10px;
    position: relative;

    .info-content {
      // height: 100%;
      // display: flex;
      align-items: center;
      justify-content: space-between;

      // padding: 20px 0;
      .info-item {
        display: inherit;
        align-items: center;
        cursor: pointer;

        .circle {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        }

        .item-info {
          align-items: center;
          padding-left: 10px;

          .number {
            height: 40px;
            font-size: 28px;
            font-weight: bold;
            line-height: 40px;
            color: #303033;
          }

          .name {
            font-size: 14px;
            font-weight: 400;
            line-height: 30px;
            color: #909399;
          }
        }
      }

      .info-item:first-child {
        padding-left: 40px;
      }

      .info-item:last-child {
        padding-right: 40px;
      }

      .number {
        height: 40px;
        // font-size: 28px;
        font-weight: bold;
        line-height: 40px;
        color: #fd0000;
        margin: 0 5px;
        cursor: pointer;
      }

      .name {
        font-size: 14px;
        font-weight: 400;
        line-height: 30px;
        color: #909399;
        cursor: pointer;
      }
    }

    .info-content.litle {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info-item {
        display: inherit;
        align-items: center;

        .circle {
          margin-top: 5px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }

        .item-info {
          align-items: center;
          padding-left: 8px;

          .number {
            height: 30px;
            font-size: 25px;
            font-weight: bold;
            line-height: 30px;
            color: #303033;
          }

          .name {
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
            color: #909399;
          }
        }
      }

      .info-item:first-child {
        padding-left: 5px;
      }

      .info-item:last-child {
        padding-right: 5px;
      }
    }

    .btn-group {
      position: absolute;
      top: calc(50%);
      width: calc(100% - 20px);

      .left-triangle {
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-right: 20px solid rgba(40, 106, 180, 0.5);
        border-bottom: 15px solid transparent;
        float: left;
        cursor: pointer;
      }

      .left-triangle.active {
        border-right: 20px solid #286ab4;
      }

      .right-triangle {
        float: right;
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-left: 20px solid rgba(40, 106, 180, 0.5);
        border-bottom: 15px solid transparent;
        position: absolute;
        right: 0;
        cursor: pointer;
      }

      .right-triangle.active {
        border-left: 20px solid #286ab4;
      }
    }
  }

  .card:last-child {
    margin-bottom: 0;
  }

  .info-title {
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    color: #303033;

    .view {
      float: right;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .info-label {
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
    color: #303033;
    font-family: DengXian;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      height: 18px;
      line-height: 18px;
      padding-left: 14px;
      border-left: 4px solid #286ab4;
    }
  }

  .color-1 {
    background: #3f8ef6;
  }

  .color-2 {
    background: #5bc36e;
  }

  .color-3 {
    background: #fc5442;
  }

  .color-4 {
    background: #f2b246;
  }

  .color-21 {
    background: #f6793f;
  }

  .color-22 {
    background: #705bc3;
  }

  .color-23 {
    background: #5bc3a4;
  }

  .color-24 {
    background: #c35b7a;
  }

  .color-25 {
    background: #f67841;
  }

  .color-26 {
    background: #fd0000;
  }

  .color-27 {
    background: #296ab3;
  }

  .color-31 {
    background: #5ec2a3;
  }

  .color-32 {
    background: #5b8cc3;
  }

  .color-33 {
    background: #c3b55b;
  }

  .color-41 {
    background: #5bc3a4;
  }

  .color-42 {
    background: #705bc3;
  }

  .color-43 {
    background: #f6793f;
  }

  .color-44 {
    background: #c35b7a;
  }
}

div /deep/.el-table__body-wrapper {
  height: 100%;
  overflow: auto;
}

/deep/.el-table__body {
  border: none;
}

.spd-pagination {
  bottom: 5px;
  position: absolute;
  right: 0;
}

.grid-num {
  font-size: 24px;
  font-weight: bold;
}
</style>
